'use server'

import { apiRequest, ApiResponse } from '../request'

export interface HrDependent {
    id: number
    employeeId: number
    name: string
    cpf: string | null
    birthDate: string | null
    relationship: string
    irDeduction: boolean
    familySalary: boolean
    healthPlan: boolean
}

const BASE = 'hr/employees'

export async function getDependents(employeeId: number): Promise<ApiResponse<HrDependent[]>> {
    return apiRequest<HrDependent[]>(`${BASE}/${employeeId}/dependents`, {})
}

export async function createDependent(employeeId: number, data: any): Promise<ApiResponse<HrDependent>> {
    return apiRequest<HrDependent>(`${BASE}/${employeeId}/dependents`, { data }, 'post')
}

export async function updateDependent(employeeId: number, id: number, data: any): Promise<ApiResponse<HrDependent>> {
    return apiRequest<HrDependent>(`${BASE}/${employeeId}/dependents/${id}`, { data }, 'patch')
}

export async function deleteDependent(employeeId: number, id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${employeeId}/dependents/${id}`, {}, 'delete')
}
